import { Component } from '@angular/core';
import { BaseAthleteAnswer } from '../base-athlete-answer';
import { FeedbackQuestion } from "../../../common/models/feedback-question";
import { NgForOf } from "@angular/common";

@Component({
  selector: 'app-feedback-borg-athlete-answer',
  templateUrl: 'feedback-borg-athlete-answer.component.html',
  standalone: true,
  imports: [
    NgForOf
  ],
  styleUrls: ['../athlete-answers.css']
})
export class FeedbackBorgAthleteAnswerComponent extends BaseAthleteAnswer {
    public static type = FeedbackQuestion.TYPE_BORG;
}
